<template>
    <b-modal v-model="modalAberto" scrollable centered title="Editar Email" header-bg-variant="secondary"
      header-text-variant="light" size="lg" @hide="closeModal">
      <b-overlay :show="carregandoModalEditar">
        <div class="container">
          <b-card :header="`Usuário: ${novoNome}`" header-class="text-center font-weight-bold">
            <b-form @submit="atualizarDados">
              <b-container fluid>
                <b-row>
                  <b-col cols="12" lg="12">
                    <b-form-group label="Email">
                      <b-form-input v-model="novoEmail"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-container>
            </b-form>
          </b-card>
        </div>
      </b-overlay>
      <template #modal-footer>
        <b-button size="sm" variant="success" @click="atualizarDados(String(itemSelecionado.ID_NOVO_USUARIO))">Salvar</b-button>
      </template>
    </b-modal>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue, Prop } from "vue-property-decorator";
import usuarioService from "@/services/administracao/usuarioService";
import { SelectValue } from "@/types/select-value";
import { NovoUsuario } from "@/types/administracao/usuarios/novo-usuario";
import { store } from "@/store";

@Component({
    components: {},
})
export default class ModalEditarUsuario extends mixins(UtilsTS, Vue) {
    @Prop({ required: true }) itemSelecionado!: NovoUsuario;
    
    modalAberto = true;

    carregandoModalEditar = false;
    novoNome = "";
    novoEmail = "";

    async mounted(){
        this.atualizarCampos();
    }

    async atualizarDados(id: string) {
        const data = {
            EMAIL: this.novoEmail,
        };
        try {
            this.carregandoModalEditar = true;
            const response = await usuarioService.alterarEmail(String(id), data);
            if(response.status === 200 || response.status === 201) {
              this.$toast.success("Email do usuário editado com sucesso!");
              this.closeModal()
              this.$emit("reload")
            }
        } catch (e: any) {
            this.tratarError(e);
            this.$toast.error("Não foi possível editar o email do usuário.");
            this.closeModal()
        } finally {
            this.carregandoModalEditar = false;
        }
    }

    cancelaredicao() {
        this.novoEmail = "";
    }

    atualizarCampos() {
        this.novoNome = this.itemSelecionado.NOME;
        this.novoEmail = this.itemSelecionado.EMAIL;
    }

    closeModal() {
        this.cancelaredicao();
        this.$emit("close");
    }

}
</script>